import { useAuthContext } from '@repo/hooks';
import { selectUserContactCount } from '@repo/redux/reducers/user/stats';
import { useSelector } from 'react-redux';

export const useContactLimitExceeded = (): boolean => {
  const { contactLimit } = useAuthContext();
  const userContactCount = useSelector(selectUserContactCount);
  return (
    contactLimit === undefined ||
    (contactLimit !== null && userContactCount && userContactCount >= contactLimit)
  );
};
